import React from "react"
import ReactDOM from "react-dom"

import App from "./App"
import { Provider } from "react-redux"
import store from "./redux"

import "bootstrap/dist/css/bootstrap.min.css"
import "rsuite/dist/rsuite.css"
import "./App.css"
import "react-loading-skeleton/dist/skeleton.css"
import { ConfigProvider } from "antd"

window.addEventListener("unhandledrejection", (event) => {
   console.error("Unhandled promise rejection:", event.reason)
})

ReactDOM.render(
   <React.StrictMode>
      <Provider store={store}>
         <ConfigProvider /* To set design token that provided by AntDesign component globally or specifically */
            theme={{
               token: {
                  /* here is for global tokens */
                  borderRadius: "5px",
               },
               components: {
                  /* here is for component tokens */
                  Select: {
                     // borderRadius: "0px",
                     // controlHeight: "2.625rem",
                     // fontSize: "14px !important",
                     optionHeight: "44px",
                     optionLineHeight: "44px",
                     optionFontSize: "14px",
                    //  fontSizeLG: "0.75rem", // 12px
                     fontSizeLG: "0.875rem", // 14px
                     controlHeightLG: "44px",
                  },
                  Input: {
                     // fontFamily: "Roboto"
                     // fontSize: "16px !important"
                     //  controlHeight: "44rem !important",
                      fontSizeLG: "0.875rem", // 14px
                    //  fontSizeLG: "0.75rem", // 12px
                  },
                  // Modal: {
                  //   borderRadius: "20px !important"
                  // }
               },
            }}
         >
            <App />
         </ConfigProvider>
      </Provider>
   </React.StrictMode>,
   document.getElementById("root"),
)
